import { YammerCache } from './types';

interface CacheItem {
  readonly value: unknown;
  readonly expiry: number;
}

export default class CacheWithExpiration implements YammerCache {
  private storage: YammerCache;
  private keyNamespace?: string;

  constructor(storage: YammerCache, keyNamespace?: string) {
    this.storage = storage;
    this.keyNamespace = keyNamespace;
  }

  public getItem<T>(key: string): T | null {
    const keyWithNamespace = this.getKeyWithNamespace(key);
    const cachedItem = this.storage.getItem<CacheItem>(keyWithNamespace);

    if (!cachedItem) {
      return null;
    }

    const { value, expiry } = cachedItem;

    if (expiry > 0 && expiry < Date.now()) {
      this.removeItem(keyWithNamespace);

      return null;
    }

    return value as T;
  }

  public setItem<T>(key: string, value: T, ttlInSeconds?: number): void {
    const keyWithNamespace = this.getKeyWithNamespace(key);
    const expiry = ttlInSeconds ? Date.now() + ttlInSeconds * 1000 : 0;
    this.storage.setItem(keyWithNamespace, { value, expiry });
  }

  public removeItem(key: string): void {
    const keyWithNamespace = this.getKeyWithNamespace(key);
    this.storage.removeItem(keyWithNamespace);
  }

  public clear(): void {
    this.storage.clear();
  }

  private getKeyWithNamespace(key: string): string {
    return this.keyNamespace ? `${this.keyNamespace}::${key}` : key;
  }
}
